import React from 'react';
import { useTranslation } from 'react-i18next';

import { Center } from '../../styles/center';
import { FullPageBox } from '../full-page-box/full-page-box';
import { Icon } from '../icon/icon';

type RedirectState = 'preparing' | 'authenticating' | 'redirecting' | 'failed';

interface Props {
  state: RedirectState;
}

export const AccessTokenRedirect = ({ state }: Props) => {
  const { t } = useTranslation();

  const getMessage = (): string => {
    switch (state) {
      case 'preparing':
        return t('accessTokenRedirect.preparingAuthentication', { ns: 'components' });
      case 'authenticating':
        return t('accessTokenRedirect.authenticating', { ns: 'components' });
      case 'redirecting':
        return t('accessTokenRedirect.redirecting', { ns: 'components' });
      case 'failed':
        return t('accessTokenRedirect.authFailed', { ns: 'components' });
      default:
        return '';
    }
  };

  return (
    <FullPageBox width="400px">
      <Center>
        {state === 'failed' && <Icon icon={['fas', 'exclamation-triangle']} />}
        <label>{getMessage()}</label>
      </Center>
    </FullPageBox>
  );
};
